/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterItemType_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuRadioSelectList_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterItemType_itemSearch";
};
export type SbSharedRefineMenuFilterItemType_itemSearch$data = SbSharedRefineMenuFilterItemType_itemSearch;
export type SbSharedRefineMenuFilterItemType_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterItemType_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterItemType_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterItemType_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuRadioSelectList_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'a2775814b44c41ccb21661998e7c392e';
export default node;
